import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const TurnRoutes = [
  {
    path: '/turns',
    name: 'ListTurns',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'turn:list'
    }
  },
  {
    path: '/turn/',
    name: 'CreateTurn',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'turn:create'
    }
  },
  {
    path: '/turn/:id',
    name: 'UpdateTurn',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'turn:update'
    }
  },
  {
    path: '/turn/view/:id',
    name: 'GetTurn',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'turn:get'
    }
  }
]
